import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import { If, Unless, Page } from '../../..'
import { selectAnyValuationIsTuneYourValue } from '../../../../store/selectors/valuationHistory'
import { selectHasCMA } from '../../../../store/selectors/home/cma'
import MortgageCoachConfirm from './MortgageCoachConfirm'
import MortgageCoachStatus from './MortgageCoachStatus'

import styles from './MortgageCoachPanelContents.module.scss'

const MortgageCoachPanelContents = ({
  refiDetails,
  hasConfirmed,
  requested,
  handleConfirm,
  handleClose,
  requestTca,
  renderRedirect,
}) => {
  const hasCma = useSelector(selectHasCMA)
  const hasTunedValue = useSelector(selectAnyValuationIsTuneYourValue)
  const hasGoneThroughTyvFlow = hasCma || hasTunedValue

  useEffect(() => {
    if (hasConfirmed && !requested && hasGoneThroughTyvFlow) {
      requestTca()
    }
  }, [hasConfirmed, requested, requestTca, hasGoneThroughTyvFlow])

  if (renderRedirect) {
    return renderRedirect
  }

  return (
    <Page>
      <Page.Body className={styles.body}>
        <Unless
          condition={(requested || hasConfirmed) && hasGoneThroughTyvFlow}
        >
          <MortgageCoachConfirm
            handleClose={handleClose}
            handleConfirm={handleConfirm}
            refiDetails={refiDetails}
          />
        </Unless>
        <If condition={(requested || hasConfirmed) && hasGoneThroughTyvFlow}>
          <MortgageCoachStatus
            handleClose={handleClose}
            refiDetails={refiDetails}
          />
        </If>
      </Page.Body>
    </Page>
  )
}

MortgageCoachPanelContents.propTypes = {
  refiDetails: PropTypes.shape({
    type: PropTypes.string,
    years: PropTypes.number,
  }),
  hasConfirmed: PropTypes.bool,
  requested: PropTypes.bool,
  handleConfirm: PropTypes.func,
  handleClose: PropTypes.func,
  requestTca: PropTypes.func,
  renderRedirect: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
}

export default MortgageCoachPanelContents
